// extracted by mini-css-extract-plugin
export var headingClamp = "RacesByDaySkeleton-module--headingClamp--aad5d";
export var icon = "RacesByDaySkeleton-module--icon--108cf";
export var title = "RacesByDaySkeleton-module--title--b3406";